// extracted by mini-css-extract-plugin
export default {"layout":"settingSection_layout__0TiFy","form":"settingSection_form__+Vu2H","saveBtn":"settingSection_saveBtn__FMjwV","logoutBtn":"settingSection_logoutBtn__0R1IO"};